<!-- eslint-disable vue/no-mutating-props, vue/no-multiple-template-root, no-undef -->
<template>
  <div class="company-settings">
    <div class="profile-edit-container add-list-container">
      <div class="profile-edit-header fl-wrap">
        <h4>Service / Company Account Settings</h4>
      </div>
      <div
        v-if="userProfileReadyToPublish"
        class="notification success fl-wrap"
      >
        <h4>Publish my profile</h4>
        <div
          v-if="!userProfile.isServicePublished"
          :class="userProfileReadyToPublish ? 'alert alert-success' : ''"
        >
          Your profile ready to publish
        </div>
        <div class="form-check form-switch">
          <input
            id="flexSwitchCheckDefault"
            class="form-check-input"
            type="checkbox"
            role="switch"
            :checked="userProfile.isServicePublished"
            :disabled="publishLoading"
            @change="$emit('publish-toggle', $event)"
          >
          <label
            class="form-check-label"
            for="flexSwitchCheckDefault"
          >
            {{
              userProfile.isServicePublished
                ? 'Your profile is published'
                : 'Publish my profile'
            }}
          </label>
          <button
            v-if="publishToggle && !userProfile.isServicePublished"
            class="btn color-bg mt-2"
            :disabled="publishLoading"
            @click="$emit('publish')"
          >
            {{ publishLoading ? 'Publishing...' : 'Confirm Publish' }}
          </button>
          <p
            v-if="publishError"
            class="text-danger mt-2"
          >
            {{ publishError }}
          </p>
          <p
            v-if="publishSuccess"
            class="text-success mt-2"
          >
            {{
              userProfile.isServicePublished
                ? 'Your profile has been published successfully!'
                : 'Your profile has been unpublished successfully!'
            }}
          </p>
        </div>
      </div>
      <div v-else>
        <h4>Profile need to:</h4>
        <ul class="requirements-list">
          <li>
            <i
              :class="
                userProfile.displayName
                  ? 'fas fa-check text-success'
                  : 'fas fa-times text-danger'
              "
            />
            Full Name: {{ userProfile.displayName ? 'Completed' : 'Required' }}
          </li>
          <li>
            <i
              :class="
                userProfile.phoneNumber
                  ? 'fas fa-check text-success'
                  : 'fas fa-times text-danger'
              "
            />
            Phone Number: {{ userProfile.phoneNumber ? 'Completed' : 'Required' }}
          </li>
          <li>
            <i
              :class="
                userProfile.postalCode
                  ? 'fas fa-check text-success'
                  : 'fas fa-times text-danger'
              "
            />
            Postal Code: {{ userProfile.postalCode ? 'Completed' : 'Required' }}
          </li>
          <li>
            <i
              :class="
                userProfile.account?.service_account?.type
                  ? 'fas fa-check text-success'
                  : 'fas fa-times text-danger'
              "
            />
            Account Type:
            {{ userProfile.account?.service_account?.type ? 'Completed' : 'Required' }}
          </li>
          <li>
            <i
              :class="
                userProfile.account?.service_account?.coverImage
                  ? 'fas fa-check text-success'
                  : 'fas fa-times text-danger'
              "
            />
            Cover Image:
            {{
              userProfile.account?.service_account?.coverImage ? 'Uploaded' : 'Required'
            }}
          </li>
          <li>
            <i
              :class="
                userProfile.account?.service_account?.company_description
                  ? 'fas fa-check text-success'
                  : 'fas fa-times text-danger'
              "
            />
            Company Description:
            {{
              userProfile.account?.service_account?.company_description
                ? 'Completed'
                : 'Required'
            }}
          </li>
          <li>
            <i
              :class="
                userProfile.account?.service_account?.working_hours
                  ? 'fas fa-check text-success'
                  : 'fas fa-times text-danger'
              "
            />
            Working Hours:
            {{
              userProfile.account?.service_account?.working_hours
                ? 'Completed'
                : 'Required'
            }}
          </li>
          <li>
            <i
              :class="
                userProfile.account?.service_account?.types &&
                  userProfile.account?.service_account?.types.length > 0
                  ? 'fas fa-check text-success'
                  : 'fas fa-times text-danger'
              "
            />
            Services:
            {{
              userProfile.account?.service_account?.types &&
                userProfile.account?.service_account?.types.length > 0
                ? 'Selected'
                : 'Required'
            }}
          </li>
          <li>
            <i
              :class="
                userProfile.account?.service_account?.images &&
                  userProfile.account?.service_account?.images.length > 0
                  ? 'fas fa-check text-success'
                  : 'fas fa-times text-danger'
              "
            />
            Gallery Images:
            {{
              userProfile.account?.service_account?.images &&
                userProfile.account?.service_account?.images.length > 0
                ? `Uploaded
            (${userProfile.account?.service_account?.images.length})`
                : 'Required'
            }}
          </li>
        </ul>
      </div>
    </div>

    <div class="profile-edit-container add-list-container">
      <div class="profile-edit-header fl-wrap">
        <h4>Detailed Information</h4>
      </div>
      <div class="custom-form">
        <label> Your Services </label>
        <div class="fl-wrap filter-tags">
          <div
            v-for="service in serviceAccountTypes"
            :key="service.id"
            class="add-list-media-header"
          >
            <input
              :id="`service-${service.id}`"
              v-model="selectedServicesModel"
              type="checkbox"
              name="services"
              :value="service.name"
            >
            <label :for="`service-${service.id}`">{{ service.name }}</label>
          </div>
        </div>

        <label>Details About Your Services</label>
        <textarea
          v-model="userProfile.account.service_account.company_description"
          cols="40"
          rows="3"
          placeholder="Please provide some informations about your Services"
          name="company_description"
        />
      </div>
    </div>

    <!-- Cover Image-->
    <div class="profile-edit-container add-list-container">
      <div class="profile-edit-header fl-wrap">
        <h4>Company Cover Image</h4>
      </div>
      <div class="custom-form">
        <div class="row">
          <div class="col-md-4">
            <div class="add-list-media-wrap">
              <form
                class="fuzone"
                :class="{ 'is-loading': coverUploadLoading }"
                @click="triggerCoverInput"
              >
                <div class="fu-text">
                  <span>
                    <i class="fas fa-image" /> Click here or drop files to upload.
                  </span>
                  <div class="photoUpload-files fl-wrap">
                    <span v-if="coverUploadLoading">Uploading... Please wait.</span>
                    <span v-else-if="coverUploadError">{{ coverUploadError }}</span>
                    <span v-else-if="coverImageUrl">Cover image uploaded</span>
                  </div>
                </div>
                <input
                  ref="coverInputLocal"
                  type="file"
                  class="upload"
                  accept="image/*"
                  :disabled="coverUploadLoading"
                  @change="$emit('cover-upload', $event)"
                >
              </form>
            </div>
          </div>
        </div>
        <div
          v-if="coverImageUrl"
          class="gallery-items fl-wrap"
        >
          <div class="row">
            <div class="col-md-6">
              <div class="gallery-item">
                <img
                  :src="coverImageUrl"
                  alt="Cover Image"
                  class="img-responsive"
                  style="height: 250px"
                >
                <div class="gallery-item-controls">
                  <a
                    href="#"
                    class="gallery-edit"
                    @click.prevent="triggerCoverInput"
                  >
                    <i class="fa fa-edit" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Company Gallery -->
    <div class="profile-edit-container add-list-container">
      <div class="profile-edit-header fl-wrap">
        <h4>Company Image Gallery</h4>
        <span class="fw-opt">Upload up to 20 images</span>
      </div>
      <div class="custom-form">
        <div class="row">
          <div class="col-md-4">
            <div class="add-list-media-wrap">
              <form
                class="fuzone"
                :class="{ 'is-loading': galleryLoading }"
                @click="triggerGalleryInput"
              >
                <div class="fu-text">
                  <span>
                    <i class="fas fa-image" /> Click here or drop files to upload.
                  </span>
                  <div class="photoUpload-files fl-wrap">
                    <span v-if="galleryLoading">Uploading... Please wait.</span>
                    <span v-else-if="errorMessage">{{ errorMessage }}</span>
                    <span v-else-if="galleryImages.length">{{ galleryImages.length }}/20 images</span>
                  </div>
                </div>
                <input
                  ref="galleryInputLocal"
                  type="file"
                  class="upload"
                  accept="image/*"
                  multiple
                  :disabled="galleryLoading || galleryImages.length >= 20"
                  @change="$emit('gallery-upload', $event)"
                >
              </form>
            </div>
          </div>
        </div>
        <div class="gallery-items fl-wrap">
          <div class="row">
            <div v-if="!galleryLoading">
              <div
                v-for="(img, index) in galleryImages"
                :key="index"
                class="col-md-3"
              >
                <div class="gallery-item">
                  <img
                    :src="img"
                    alt="Gallery Image"
                    class="img-responsive"
                  >
                  <div class="gallery-item-controls">
                    <a
                      href="#"
                      class="gallery-delete"
                      @click.prevent="$emit('remove-image', index)"
                    >
                      <i class="fa fa-trash" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              Image Loading
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Working Hours -->
    <div class=" ">
      <div class="custom-form mt-2">
        <div
          class="col-md-6"
          style="display: flex"
        >
          <div class="box-widget-wrap">
            <div class="box-widget-item fl-wrap">
              <div class="box-widget-item-header">
                <h3>Working Hours :</h3>
              </div>
              <div class="box-widget opening-hours">
                <div class="box-widget-content">
                  <span class="current-status"><i class="fa fa-clock" /> Now Open</span>
                  <ul>
                    <li
                      v-for="day in ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']"
                      :key="day"
                    >
                      <span class="opening-hours-day">{{ day.charAt(0).toUpperCase() + day.slice(1) }} </span>
                      <span class="opening-hours-time">
                        <input
                          v-model="workingHoursModel[day].open"
                          class="opening-hours-time"
                          type="time"
                        >
                        <input
                          v-model="workingHoursModel[day].close"
                          class="opening-hours-time"
                          type="time"
                        >
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="profile-edit-container">
      <div class="custom-form mt-2">
        <button
          class="btn big-btn color-bg flat-btn"
          @click="$emit('save')"
        >
          {{ saveLoading ? 'Saving...' : 'Save Changes' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';

const props = defineProps({
  userProfile: { type: Object, required: true },
  userProfileReadyToPublish: { type: Boolean, required: true },
  publishToggle: { type: Boolean, required: true },
  publishLoading: { type: Boolean, default: false },
  publishError: { type: String, default: null },
  publishSuccess: { type: Boolean, default: false },
  serviceAccountTypes: { type: Array, required: true },
  selectedServices: { type: Array, required: true },
  coverUploadLoading: { type: Boolean, default: false },
  coverUploadError: { type: String, default: null },
  coverImageUrl: { type: String, default: null },
  galleryLoading: { type: Boolean, default: false },
  errorMessage: { type: String, default: null },
  galleryImages: { type: Array, required: true },
  workingHours: { type: Object, required: true },
  saveLoading: { type: Boolean, default: false }
});

const emit = defineEmits([
  'update:selectedServices',
  'update:workingHours',
  'publish-toggle',
  'publish',
  'cover-upload',
  'gallery-upload',
  'remove-image',
  'save'
]);

import { ref } from 'vue';

const coverInputLocal = ref(null);
const galleryInputLocal = ref(null);

const triggerCoverInput = () => {
  if (!props.coverUploadLoading && coverInputLocal.value) {
    coverInputLocal.value.click();
  }
};

const triggerGalleryInput = () => {
  if (!props.galleryLoading && galleryInputLocal.value && props.galleryImages.length < 20) {
    galleryInputLocal.value.click();
  }
};

const selectedServicesModel = computed({
  get: () => props.selectedServices,
  set: (val) => emit('update:selectedServices', val)
});

const workingHoursModel = computed({
  get: () => props.workingHours,
  set: (val) => emit('update:workingHours', val)
});
</script>


